import $ from 'jquery';
import LINEARVIEW from 'h2g-linear-view/js/linearview';
import H2GDIALOG from 'h2g-material/dialogs/h2g-dialog';
import {_str,DATE_UTIL} from 'h2g-test-results/js/util';
import {H2GRESULTS,TR,getRouteringTestResults} from 'h2g-test-results/js/test-results';
import H2GHISTORY from 'h2g-test-history/js/test-history';
import DEVICEDETAILS from 'lan-scan/js/device-details';
import {saveAs} from 'file-saver';

angular.module("SupportAgent")
.controller(
 'TabCircleController',
 ['$rootScope', '$scope', '$filter', 'EventHandler', '$timeout',
  'L','INTERACT','C11N',
  'spectrumData','tracerouteData',
 function($rootScope, $scope, $filter, EventHandler, $timeout,
          L,INTERACT,C11N,
          spectrumData,tracerouteData) {
  $rootScope.current_circle_group = "";
  $rootScope.showTraceroute=false;
  var components = { device:"device", wifi_router:"wifi_router", internet:"internet",
                     mobile_bs:"mobile_bs", fixed_line:"fixed_line", wifi:"wifi",
                     mobile_bb:"mobile_bb", mobile:"mobile", router:"wifi_router" };
  var circular_data = {
   device: {n:"device",c1:"device",t_id:"test_result_header_device",e:"unknown"}, 
   internet: {n:"internet",c1:"internet",t_id:"test_result_header_internet",e:"unknown"},
   wifi_router: {n:"wifi_router",c1:"router",t_id:"test_result_header_wifi_router",e:"unknown"},
   fixed_line: {n:"fixed_line",c1:"router",c2:"internet",t_id:"test_result_header_fixed_line",e:"unknown"},
   wifi: {n:"wifi",c1:"device",c2:"router",t_id:"test_result_header_wifi_network",e:"unknown"},
   mobile_bb: {n:"mobile_bb",c1:"internet",c2:"network",t_id:"test_result_header_mobile_backbone",e:"unknown"},
   mobile_bs: {n:"mobile_bs",c1:"network",t_id:"test_result_header_base_station",e:"unknown"},
   mobile: {n:"mobile",c1:"network",c2:"device",t_id:"test_result_header_mobile_network",e:"unknown"}
  };

  function onCirclularViewOrbitClick(group, state) {
   if(state=='summary') {
    TR.evaluate(false,true);
    $scope.showIssuesScreen();
    return;
   }
   $rootScope.current_circle_group = components[group];
   $rootScope.showTestStatusTable = true;
   $scope.group = comp_disp_names[group];
   $rootScope.updateStatusTable(group);
   $rootScope.bLoadgraph = true;
   $scope.hideSubHeader = false;
   circular_data[group].e=state;
   onCircularviewComponentsClick(components[group]);
   loadResultsScreen(components[group]);
   openResultsScreen();
  }

  $timeout(function() {
   $rootScope.orbitX.create('#clientArea',function(group,state) {onCirclularViewOrbitClick(group,state)});
  },0);

  $scope.cancelDiagnosis = function() {
   EventHandler.APILAYER.sendMessage({
    convid:$rootScope.conversationID,
    channelid: INTERACT.D.xaction.channel.diagreq,
    msg:'6|diagnose|{"type":"stop"}',
    devid:$rootScope.deviceID});
   $rootScope.showDiagnoseOverlayScreen=false;
  };

  $rootScope.onClickLinearViewOrbit = function(e,r) {
   if(r.id=='summary') {
    $scope.showIssuesScreen();
    return;
   }
   $rootScope.current_circle_group = components[r.id];
   $rootScope.showTestStatusTable = true;
   $scope.showTestHistoryScreen=false;
   $scope.group = comp_disp_names[r.id];
   $rootScope.bLoadgraph = true;
   $scope.hideSubHeader = false;
   onLinearviewComponentsClick(r.id);
   openResultsScreen();
  };

  function onLinearviewComponentsClick(id) {
   var img1="", img2="", bgimg="";
   switch(id) {
    case 'device':
    case 'router':
    case 'wifi_router':
    case 'internet':
     img1=WTG.img("rs_"+id+".png");
     bgimg=WTG.img("bg_"+id+".jpg");
     break;
    case 'fixed_line':
    case 'wifi':
     img1 = WTG.img("rs_"+$rootScope.wtg_fixedline.components[id].c1+".png");
     img2 = WTG.img("rs_"+$rootScope.wtg_fixedline.components[id].c2+".png");
     bgimg = WTG.img("bg_internet.jpg");
     break;
    default:
     L.trace("case not handled - "+id); // TODO: very informative
   }
   TR.setResultScreenHeaderInfo({
    title: _str($rootScope.wtg_fixedline.components[id].t_id),
    comp: $rootScope.wtg_fixedline.components[id].n,
    header: $rootScope.wtg_fixedline.components[id].e,
    img: bgimg,
    icon1: img1,
    icon2: img2 });
   loadResultsScreen(components[id]);
   $scope.status_table_header = TR.rsh.title;
   $scope.removeHeaderCls();
   $("#tableHeader").addClass(TR.rsh.header);
  }

  function onCircularviewComponentsClick(id) {
   var img1="", img2="", bgimg="";
   switch(id) {
    case 'device':
    case 'wifi_router':
    case 'internet':
    case 'mobile_bs':
     img1=WTG.img("rs_"+circular_data[id].c1+".png");
     bgimg=WTG.img("bg_"+circular_data[id].c1+".jpg");
     break;
    case 'fixed_line':
    case 'wifi':
    case 'mobile_bb':
    case 'mobile':
     img1 = WTG.img("rs_"+circular_data[id].c1+".png");
     img2 = WTG.img("rs_"+circular_data[id].c2+".png");
     bgimg = WTG.img("bg_internet.jpg");
     break;
    default:
     L.trace("case not handled - "+id);// TODO: also very informative
   }
   TR.setResultScreenHeaderInfo({
    title: _str(circular_data[id].t_id),
    comp: circular_data[id].n,
    header: circular_data[id].e,
    img:bgimg,
    icon1: img1,
    icon2: img2 });
   loadResultsScreen(components[id]);
   $scope.status_table_header = TR.rsh.title;
   $scope.removeHeaderCls();
   $("#tableHeader").addClass(TR.rsh.header);
   if($scope.show_st_BackBtn) H2GDIALOG.show_portal_results_screen();
  }

  /*$scope.mdDialogOverLayScreenClick =function() {
   H2GDIALOG.mdDialog.hide();
  }*/
  $scope.onStatuTableBackBtnClick = function() {
   $rootScope.showTestStatusTable=false;
   openResultsScreen();
   $rootScope.updateStatusTable($rootScope.current_circle_group);
  };
 
  function loadWifiSpectrumScreen() {
   $scope.showWifiSpectrumPage=true;
   $scope.show_st_BackBtn = true;
   $rootScope.showTestStatusTable=false;
   $scope.status_table_header = $rootScope.strings.wifi_spectrum;
   $scope.removeHeaderCls();
   $("#tableHeader").addClass('more_screen_bg');
  }

  function loadTracerouteScreen() {
   $rootScope.showTraceroute=true;
   $scope.show_st_BackBtn = true;
   $rootScope.showTestStatusTable=false;
   $scope.status_table_header = $rootScope.strings.trace_route;
   $scope.removeHeaderCls();
   $("#tableHeader").addClass('more_screen_bg');
  }

  $scope.showManualSelectionPage= $scope.$applyAsync.bind($scope,()=>{
   $scope.show_st_BackBtn=false;
   $scope.showWifiSpectrumPage=false;
   $scope.showWifiSpectrumManualPage=true;
   $scope.show_st_BackBtn=true;
   $scope.status_table_header="";
  });

  H2GDIALOG.create_MdDialog = function(inputCtrl,message,template){
   $rootScope.create_MdDialog(inputCtrl,message,template);
  };

  H2GDIALOG.create_customDialog = function(ctrlName,message,ev){
   $rootScope.create_customDialog(ctrlName,message,ev);
  };

  H2GDIALOG.show_generic_overlay = function(ctx,td,msg,errCode){
   var routering_res = getRouteringTestResults();
   var tr64 = (routering_res && routering_res.res_data && routering_res.res_data.type && routering_res.res_data.type.toLowerCase()=="tr64");
   var obj={};
   obj.tr64 = tr64;
   obj.td = td;
   obj.msg = msg;
   obj.errCode = errCode;
   $rootScope.show_generic_overlay(ctx,obj);
  };

  H2GDIALOG.show_portal_results_screen = function() {
   $scope.onStatuTableBackBtnClick();
  };

  H2GRESULTS.applyFix = function(testTitle,testName,testId,fix,result_data,busyTxt,un,pw){
   //Note:fix payload contains following information like normal test request
   //test/fix|fix-id|silent/non-silent|more info about fix
   //ex:1|148|0|resultdata
   switch(fix) {
    case 'router_log':
   EventHandler.APILAYER.sendMessage({
    convid:$rootScope.conversationID,
    channelid: INTERACT.D.xaction.channel.diagreq,
    msg:"1|174|0",
    devid:$rootScope.deviceID});
     break;
    case 'set_wifi_channel':
     EventHandler.APILAYER.sendMessage({
      convid:$rootScope.conversationID,
      channelid: INTERACT.D.xaction.channel.diagreq,
      msg:"1|140|0|"+JSON.stringify({"test_name": testName ,
       "test_id": testId,
       "result_data":(angular.isString(result_data)?JSON.parse(result_data):result_data)}),
      devid:$rootScope.deviceID});
     break;
    case 'manage_wifi':
     EventHandler.APILAYER.sendMessage({
      convid:$rootScope.conversationID,
      channelid: INTERACT.D.xaction.channel.diagreq,
      msg:"1|148|0|"+JSON.stringify({"test_name": testName ,
       "test_id": testId,
       "result_data":(angular.isString(result_data)?JSON.parse(result_data):result_data)}),
      devid:$rootScope.deviceID});
     break;
    case 'get_router_creds':
     var msg = '|0| {"test_name": "'+testName+'","test_id": "'+testId+'","un": "'+un+'","pw": "'+pw+'"}';
     EventHandler.APILAYER.sendMessage({
      convid:$rootScope.conversationID,
      channelid: INTERACT.D.xaction.channel.diagreq,
      msg:"1|139"+msg,
      devid:$rootScope.deviceID});
     break;
    case 'turn_on_location':
     EventHandler.APILAYER.sendMessage({
      convid:$rootScope.conversationID,
      channelid: INTERACT.D.xaction.channel.diagreq,
      msg:"1|166|0|"+JSON.stringify({"test_name": testName ,
       "test_id": testId,
       "result_data":(angular.isString(result_data)?JSON.parse(result_data):result_data)}),
      devid:$rootScope.deviceID});
     break;
   }
  };

  H2GRESULTS.retriveFix = function(fix,fixId,title) {
   switch(fix) {
    case 'router_log':
     $rootScope.get_json("fix_results.tests."+fix+"."+fixId,function(e,r) {
      var logfileContent = r.details;
      try {
       var blob = new Blob([logfileContent], {type: "text/plain;charset=utf-8"});
       saveAs(blob,"router log");
      }catch(error) {
       L.error({err:error});
      }
     });
     break;
    case 'set_wifi_channel':
     $rootScope.get_json("fix_results.tests."+fix+"."+fixId,function(e,r) {
      H2GDIALOG.showInputTemplate(H2GDIALOG.popupCtrl,{"header" : $rootScope.strings.wifi_spectrum_btn_switch_channel,"status" : r.details});
     });
     break;
    case 'get_router_creds':
     $rootScope.get_json("fix_results.tests."+fix+"."+fixId,function(e,r) {
      if(r.details=="Invalid credentials") {
       H2GDIALOG.show_generic_overlay('router_cred_overlay',{fix:fix,title:title},"Invalid credentials. Please try again.",1);
      }
      else return $rootScope.show_generic_overlay('generic_info',{title:"Router Status",desc:"credentials accepted",btn:_str("ok_btn")});
     });
     break;
   }
  };

  H2GRESULTS.open_screen_on_more_click = function(screen/*,component*/) {
   switch(screen) {
    case 'VisualTraceRoute':
     tracerouteData.set({history_show:false});
     loadTracerouteScreen();
     break;
    case 'wifichannels':
     spectrumData.set({history:false});
     loadWifiSpectrumScreen();
     break;
    case 'DeviceList':
     loadDeviceListScreen();
     break;
    default:
     L.trace("case not handled - "+screen);
   }
  };

  H2GRESULTS.run_test =function(name,params) {
   if($rootScope.show_live_diagnostics_disabled_info()) return;
   var index = $rootScope.orbitData.indexOf($filter('filter')($rootScope.orbitData, {tn: name})[0]);
   var tinfo = $rootScope.orbitData[index];
   $rootScope.launchTest(tinfo.tid,params);
  };

  H2GRESULTS.showBusyState = function() {
   $rootScope.showTestHistoryLoadingScreen=true;
  };

  H2GRESULTS.hideBusyState = function() {
   $rootScope.showTestHistoryLoadingScreen=false;
  };

  H2GRESULTS.showManualSelectionPage = function() {
    $scope.showManualSelectionPage();
  };

  function loadResultsScreen(component) {
   if($rootScope.showTestStatusTable)  return H2GRESULTS.update(component);
   $rootScope.$applyAsync(function(){
    $rootScope.showTestStatusTable = true;
   });
  }
  H2GHISTORY.showBusyState = function() {
   $rootScope.showTestHistoryLoadingScreen=true;
  };

  H2GHISTORY.hideBusyState = function() {
   $rootScope.showTestHistoryLoadingScreen=false;
  };

  function openResultsScreen() {
   if($scope.showDeviceDetailsScreen) {
    $scope.status_table_header = $rootScope.strings.lan_devices;
    $scope.showDeviceListScreen=true;
    $scope.showDeviceDetailsScreen=false;
   } else if($scope.showWifiSpectrumManualPage&&!C11N.is_ios) { /* TODO: by no means should C11N track iosness of current device! */
    $scope.showWifiSpectrumPage=true;
    $scope.showWifiSpectrumManualPage=false;
    $scope.status_table_header = $rootScope.strings.wifi_spectrum;
   } else {
    $scope.showTestHistoryScreen=false;
    $rootScope.showTestStatusTable=true;
    $rootScope.showTraceroute=false;
    $scope.show_st_BackBtn=false;
    $scope.showWifiSpectrumPage=false;
    $scope.showDeviceListScreen=false;
    $scope.showDeviceDetailsScreen=false;
    $scope.showWifiSpectrumManualPage=false;
    $scope.status_table_header = TR.rsh.title;
   }
  }

  H2GHISTORY.showHistoryScreen = function(test) {
   $rootScope.LoadTestHistoryScreen(test);
  };

  H2GHISTORY.get_json = function(tinfo,cb) {
   $rootScope.get_json("test_results.tests."+tinfo.testName,function(e,r) {
    cb(e, Object.values(r||{})
     .filter(function(x){ return tinfo.component==x.component })
     .map(function(x) {
      x.time = x.time||DATE_UTIL.getTimeStampForUI(x.ts_last||x.ts);
      return x;
     })
    );
   });
   $scope.status_table_header = tinfo.title;
   $scope.status_table_header+=" History";
  };

  $rootScope.LoadTestHistoryScreen = function(/*test*/) {
   $rootScope.showTestStatusTable=false;
   $scope.showTestHistoryScreen=true;
   $scope.showDeviceListScreen=false;
   $scope.show_st_BackBtn = true;
   H2GHISTORY.root_path = "/";
   H2GHISTORY.is_portal = true;
   H2GHISTORY.init($scope,$timeout);
   H2GHISTORY.controller($scope);
  };

  function loadDeviceListScreen(){
   $scope.showDeviceListScreen=true;
   $scope.showDeviceDetailsScreen=false;
   $scope.show_st_BackBtn = true;
   $rootScope.showTestStatusTable=false;
   $scope.status_table_header = $rootScope.strings.lan_devices;
   $scope.removeHeaderCls();
   $("#tableHeader").addClass('more_screen_bg');
  }

  $scope.showDeviceDetails = function(details){
   $scope.showDeviceListScreen=false;
   $scope.showDeviceDetailsScreen=true;
   DEVICEDETAILS.init($scope,{"p":{"id":details.MAC}});
   DEVICEDETAILS.controller($scope);
   $scope.status_table_header = $rootScope.strings.device_details;
  };

  LINEARVIEW.root_path = "/";
  LINEARVIEW.init($scope,null);
  LINEARVIEW.is_portal = true;
  var comp_disp_names = {
   device: $rootScope.strings.test_result_header_device,wifi_router:$rootScope.strings.test_result_header_wifi_router,
   internet:$rootScope.strings.test_result_header_internet,mobile_bs:$rootScope.strings.test_result_header_base_station,
   fixed_line:$rootScope.strings.test_result_header_fixed_line,wifi:$rootScope.strings.test_result_header_wifi_network,
   mobile:$rootScope.strings.test_result_header_mobile_network,mobile_bb:$rootScope.strings.test_result_header_mobile_backbone,
   router:$rootScope.strings.test_result_header_wifi_router
  };

  $scope.refreshCircle = function() {
   $('#circlerefreshicon').addClass('fa-spin');
   $rootScope.fetch_status();
   $timeout(function() {
    // TODO: that's a nice way to track it…
    $('#circlerefreshicon').removeClass('fa-spin');
   }, 10000);
  };

  $rootScope.updateStatusTable = function(group) {
   if($rootScope.showTestStatusTable) {
    if(!$rootScope.isHidden("h2g-linear-view")) onLinearviewComponentsClick(group);
    else onCircularviewComponentsClick(group);
   }
  };

  $scope.$on('updateRouterConfigurationInfo' , function (event,result,resData/*,ecode*/) {
   $rootScope.loadRouterConfiguration(resData);
  });

  window.addEventListener("message", function(event) {
   L.trace( "received a message from "+event.module+" module. data:"+ JSON.stringify(event.data));
   /* TODO: this is from the module that I've killed because it was a pointless
    * disaster, if at some point we will need to make this work, we should work
    * on it separately
    if($rootScope.wifi_configuration_iframeID) notify_module($rootScope.wifi_configuration_iframeID,{data:"OK"});
    */
  });
 
  $scope.removeHeaderCls = function() {
   ['ok','warn','prob','ignore','skip','more_screen_bg'].forEach(function(c) {
      if($("#tableHeader").hasClass(c)) $("#tableHeader").removeClass(c);
   });
  };

  $rootScope.performManualTest =function(name,params,header,id) {
   $rootScope.launchTest(id);
  };

  $scope.showIssuesScreen = function() {
   TR.rsh.comp = "errors";
   $rootScope.current_circle_group="errors";
   $scope.showTestHistoryScreen=false;
   $rootScope.showTestStatusTable=true;
   $rootScope.showTraceroute=false;
   $scope.show_st_BackBtn=false;
   $scope.showWifiSpectrumPage=false;
   $scope.showDeviceListScreen=false;
   $scope.showDeviceDetailsScreen=false;
   loadResultsScreen("errors");
   $scope.status_table_header = $rootScope.strings.str_issues_found;
   $scope.removeHeaderCls();
   $("#tableHeader").addClass($scope.errorScreenEvaluation);
  };

  $scope.onClickDiagnosticBtn=function(id) {
   EventHandler.APILAYER.sendMessage({
    convid:$rootScope.conversationID,
    channelid: INTERACT.D.xaction.channel.diagreq,
    msg:'6|diagnose|{"type":"start"}',
    devid:$rootScope.deviceID });
   $rootScope.showDiagnoseOverlayScreen=true;
   id='internet';
   $rootScope.current_circle_group = components[id];
   $rootScope.showTestStatusTable = true;
   $scope.showTestHistoryScreen=false;
   $scope.group = comp_disp_names[id];
   $rootScope.bLoadgraph = true;
   onLinearviewComponentsClick(id);
   openResultsScreen();
  };

}]);
/* vim:set ts=8 sw=1 expandtab: */
